// extracted by mini-css-extract-plugin
export default {"SliderIconNext":"SliderNavigationArrows__SliderIconNext___XwZ8k","SliderIconPrev":"SliderNavigationArrows__SliderIconPrev___l235J"};